<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'app',
    
    data(){
    	return {
    		
    	}
    },
    created(){
    	
    }
}
</script>
<style lang="scss" scoped>
    #app {
        overflow: hidden;
        min-width: 1320px;
        height: 100%;
        font-family: '微软雅黑';
    }
</style>



// WEBPACK FOOTER //
// src/App.vue